/* eslint-disable no-undef */

import APIClient from '../state-charts/api-client';

const map_config = (google, merchant) => {
  return {
    center: {
      lat: merchant.country_default_latitude,
      lng: merchant.country_default_longitude,
    },
    zoom: 7,
    maxZoom: 14,
    minZoom: 4,
    mapTypeControl: false,
    scaleControl: false,
    streetViewControl: false,
    rotateControl: false,
    fullscreenControl: false,
    zoomControlOptions: {
      position: google.maps.ControlPosition.RIGHT_CENTER,
    },
  };
};

async function initWorkersMap(google, merchant) {
  const map = new google.maps.Map(
    document.getElementById('info_map'),
    map_config(google, merchant)
  );
  const data = await APIClient.get_workers_for(merchant.merchant_uuid);
  const markers = data.markers.map(m => {
    return new google.maps.Marker({
      position: { lat: m[0], lng: m[1] },
    });
  });

  return new MarkerClusterer(map, markers, {
    imagePath: '/vendor/marker-cluster/m',
    maxZoom: 14,
  });
}

export default initWorkersMap;
